<span class="c-field-value" *ngIf="languages[data]">
  <img class="c-field-value__icon" *ngIf="languages[data].img" src="{{ languages[data].img }}" width="20" height="20" />
  <span class="c-field-value__text" *ngIf="type === 'default'"
    >{{ data | uppercase }}
    <span class="c-field-value__text -gray"><span class="c-field-value__deliver">/</span>{{ languages[data].name }}</span></span
  >
  <span *ngIf="type === 'short'">&nbsp;&nbsp;{{ languages[data].name }}</span>
</span>
<div *ngIf="!languages[data]">
  <span class="text-color text-color--green" i18n="@@common.all_languages">All Languages</span>
</div>
